import {
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from 'reactstrap';

function ReportExportDropdown({
    onCSV,
    onExcel,
    onPDF,
    onImage,
    disabled = false,
    label = 'Download',
    excelLabel = 'Excel',
    pdfLabel = 'PDF',
}) {
    const items = [
        onExcel ? { key: 'excel', label: excelLabel, icon: 'fa-file-excel-o', onClick: onExcel } : null,
        onCSV ? { key: 'csv', label: 'CSV', icon: 'fa-file-text-o', onClick: onCSV } : null,
        onPDF ? { key: 'pdf', label: pdfLabel, icon: 'fa-file-pdf-o', onClick: onPDF } : null,
        onImage ? { key: 'image', label: 'Image', icon: 'fa-file-image-o', onClick: onImage } : null,
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <UncontrolledButtonDropdown className="list-page-toolbar-export-dropdown">
            <DropdownToggle
                caret
                color="primary"
                outline
                className="list-page-toolbar-export-dropdown-btn"
                disabled={disabled}
            >
                <i className="fa fa-download" aria-hidden="true" />
                {' '}
                {label}
            </DropdownToggle>
            <DropdownMenu
                container="body"
                strategy="fixed"
                className="list-page-toolbar-export-menu"
            >
                {items.map((item) => (
                    <DropdownItem
                        key={item.key}
                        onClick={item.onClick}
                        disabled={disabled}
                    >
                        <i className={`fa ${item.icon}`} aria-hidden="true" />
                        {' '}
                        {item.label}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledButtonDropdown>
    );
}

export default ReportExportDropdown;
